import React from "react";
import {
  useUpdateConsentMasterMutation,
  useUpdateOnboardWorkshopDataMutation,
} from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";

interface IPROPS {
  storedWorkshopData: any;
  closeModal: any;
  refetch: any;
}

const ActiveConsent: React.FC<IPROPS> = ({
  storedWorkshopData,
  closeModal,
  refetch,
}) => {
  const [updateConsentTrigger] = useUpdateConsentMasterMutation();

  console.log(storedWorkshopData, "storedWorkshoppp");

  const activateWorkshophandler = async () => {
    const payload = {
      code: storedWorkshopData?.code,
      name: storedWorkshopData?.name,
      is_active: true,
    };

    const response = await updateConsentTrigger({
      id: storedWorkshopData?.id,
      body: payload,
    });

    if (response?.data) {
      refetch();
      closeModal();
    }
    console.log(response, "responsenne");
  };

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <i
          style={{
            fontSize: "26px",
            color: "black",
            cursor: "pointer",
          }}
          className="bi bi-x"
          onClick={closeModal}
        ></i>
      </div>
      <div
        style={{
          color: "#3071e4",
          fontSize: "18px",
          fontFamily: "karbon",
        }}
      >
        Are you sure?
      </div>
      <div
        style={{
          marginBottom: "15px",
          fontSize: "16px",
          fontFamily: "karbon",
          color: "#666666",
        }}
      >
        Do you really want to <span style={{ color: "#f15a22" }}>Activate</span>{" "}
        this consent?
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <button
          onClick={activateWorkshophandler}
          style={{
            padding: "10px 25px",
            borderRadius: "20px",
            background: `${selectedButtonBackgoundColors}`,
            color: `${selectedButtonColors}`,
            border: `1px solid ${selectedBorderColor}`,
            fontFamily: "karbon",
          }}
        >
          Confirm
        </button>
        <button
          className="btn btn-light"
          style={{ fontFamily: "karbon" }}
          onClick={closeModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ActiveConsent;
